<template>
  <cube-float-ball
    bindclick="handleClick">
    <image
      class="float-ball-demo"
      src="https://dpubstatic.udache.com/static/dpubimg/TRSp1qfRVjgrDF9Lr-OyN_service-assist.png"></image>
  </cube-float-ball>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    methods: {
      handleClick() {
        console.log('click')
      }
    }
  })
</script>

<style lang="stylus">
.float-ball-demo
  width 50px
  height 50px
  border-radius 50%
  box-shadow 0 1px 12px rgba(0, 0, 0, .2)
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-float-ball": "@mpxjs/mpx-cube-ui/src/components/float-ball/index"
    }
  }
</script>
